import { makeStyles } from '@material-ui/core/styles';
import { backgroundLight } from '../../styles/themes/palettes/light';

const styles = makeStyles(theme => ({
  container: {
    maxWidth: theme.spacing(150),
    backgroundColor: backgroundLight,
    color: 'initial',

    '& .welcome-modal-button': {
      color: theme.palette.primary.main,
    },

    [theme.breakpoints.up('md')]: {
      ...theme.globalStyles.scrollbar(theme),
    },
  },
}));

export default styles;
